import { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5percent from "@amcharts/amcharts5/percent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function PieChartDetails(props) {
  const history = useHistory();
  let myData = props?.data || [];
  const t = props?.t;

  
  useLayoutEffect(() => {
   if (!myData?.length) return;

    let root = am5.Root.new("pieChart");

    // Remove amCharts logo
    root._logo.dispose();

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
      })
    );

    // Define data
    let data = myData;

    // Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        name: "Hiring Source",
        valueField: "value",
        categoryField: "title",
      })
    );

    series.slices.template.events.on("click", function (event) {
      let jobPortalId = event?.target?._dataItem?.dataContext?.id;
      if (jobPortalId && jobPortalId !== "null") {
        history.push(
          `/all-applications?job_portal_name=${jobPortalId}&filterValue=true`
        );
      }
    });

    series.data.setAll(data);

    // Disabling labels and ticks
    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    // Set labels style
    series.labels.template.setAll({
      fontSize: "14px", // Set font size
      fill: am5.color(0x000000), // Optional: set label color
      textAlign: "center", // Optional: center-align text
    });

    // Tooltip configuration
    series.slices.template.setAll({
      tooltipText: "{category}: {value}",
      tooltip: am5.Tooltip.new(root, {
        labelText: "{category}: {value}",
        background: am5.RoundedRectangle.new(root, {
          fill: am5.color("#FF0000"), // Tooltip background color red
          stroke: am5.color("#fff"), // Tooltip border color black
          strokeWidth: 1,
        }),
        autoTextColor: false,
      }),
    });

    series.slices.template.states.create("active", {
      shiftRadius: 0,
      stroke: am5.color(0x995522),
      strokeWidth: 1,
    });

    // Calculate total values
    let totalValue = myData.reduce((sum, item) => sum + (item.value || 0), 0);

    // Prepare custom legend data
    let legendData = myData.map(item => {
      let value = item.value || 0;
      let percentage = totalValue ? (value / totalValue) * 100 : 0;
      let formattedValue = Number.isInteger(percentage)
        ? `${percentage.toFixed(0)}%`
        : `${percentage.toFixed(2)}%`;

      return {
        name: item.title.trim(), // Remove unnecessary spaces
        value: formattedValue.trim(), // Remove unnecessary spaces
      };
    });

    // Create the legend with padding adjustment
    let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        layout: root.verticalLayout,
        paddingTop: 10, // Adjust this value to reduce the gap
      })
    );

    const getLegendLabelStyle = () => {
      const width = window.innerWidth;
      if (width <= 575) {
        return "font-size:9px;text-align:left;padding:0 5px;width:260px;margin-right:auto; line-height:14px;"; // Styles for <= 575px
      } else if (width <= 1366) {
        return "font-size:10px;text-align:left;padding:0 5px;width:100%;margin-right:auto; line-height:14px;"; // Styles for 576px to 1366px
      }
      return "font-size:9px;text-align:left;padding:0 5px;width:360px;margin-right:auto; line-height:14px;"; // Default styles for > 1366px
    };

    // Custom legend label
    // legend.labels.template.setAll({
    //   html: `<div style="${getLegendLabelStyle()}"><strong>{name}</strong>: {value}</div>`,
    // });

    // legend.data.setAll(legendData);

    return () => {
      root.dispose();
    };
  }, [props?.data]);
  if (!myData.length) {
    return (
      <h5 className="text-center p-4">{t(`Dashboard.No data Available`)}</h5>
    );
  }


  return <div id="pieChart" style={{ width: "100%", height: "250px" }}></div>;
}

export default PieChartDetails;
